import { render } from "./SubDivision.vue?vue&type=template&id=360537b1&scoped=true"
import script from "./SubDivision.vue?vue&type=script&lang=js"
export * from "./SubDivision.vue?vue&type=script&lang=js"

import "./SubDivision.vue?vue&type=style&index=0&id=360537b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-360537b1"]])

export default __exports__